import React from 'react';
import { KeyRound, MapPinOff, Scale, ShieldHalf, Trash2, UserX } from 'lucide-react';
import { useLocale } from '../../context/LocaleContext';

const SECURITY_ICONS = [KeyRound, Trash2, MapPinOff, UserX, Scale, ShieldHalf];

// index.tsx'ten ayrıştırıldı — landing "Security" bölümü
export default function Security({ L }: any) {
  const { locale } = useLocale();
  const SECURITY_BADGES = L.security.badges.map((text: string, i: number) => ({ icon: SECURITY_ICONS[i], text }));
  return (
    <>
        <section id="security" className="py-16 md:py-24 relative">
          <div className="divider-glow mb-16 mx-12" />
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              {/* Left */}
              <div>
                <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#34C3A0] uppercase tracking-widest font-semibold mb-6">
                  {L.security.badge}
                </div>
                <h2
                  className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-6"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {L.security.titlePrefix} <span className="gradient-text">{L.security.titleHighlight}</span>
                </h2>
                <p className="reveal reveal-delay-2 text-gray-400 text-lg leading-relaxed mb-8">
                  {L.security.subtitle}
                </p>

                <div className="reveal reveal-delay-3 space-y-4">
                  {L.security.bars.map((item, i) => (
                    <div key={i}>
                      <div className="flex justify-between text-sm mb-1">
                        <span className="text-gray-300">{item.label}</span>
                        <span className="text-[#34C3A0] font-semibold">{item.val}</span>
                      </div>
                      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
                        <div
                          className="h-full rounded-full transition-all"
                          style={{
                            width: `${item.pct}%`,
                            background: 'linear-gradient(90deg, #34C3A0, #FFB020)',
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right — Badges */}
              <div className="reveal-right reveal grid grid-cols-2 gap-4">
                {SECURITY_BADGES.map((b, i) => {
                  const BadgeIcon = b.icon;
                  return (
                  <div
                    key={i}
                    id={`security-badge-${i}`}
                    className={`reveal reveal-delay-${i + 1} glass-panel gradient-border rounded-2xl p-5 flex flex-col items-center text-center gap-3 hover:scale-105 transition-transform duration-300`}
                  >
                    <BadgeIcon size={28} className="text-[#34C3A0]" />
                    <span className="text-xs text-gray-300 font-medium leading-snug">{b.text}</span>
                  </div>
                  );
                })}
              </div>
            </div>

            {/* Veri akışı diyagramı — görsel dille "sıfır güven" anlatımı (yalnız TR; görsel metni Türkçe) */}
            {locale !== 'en' && (
              <div className="reveal mt-16">
                <img
                  src="/assets/guvenlik-diyagram.png"
                  alt="ParkMesaj veri akışı: QR taranır, şifreli köprü üzerinden numara gizli kalarak sürücüye ulaşır"
                  className="w-full max-w-4xl mx-auto rounded-2xl border border-white/10"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </section>

    </>
  );
}
